import { render, staticRenderFns } from "./SubmissionFormForReview.vue?vue&type=template&id=5e0197eb&scoped=true&"
import script from "./SubmissionFormForReview.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormForReview.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormForReview.vue?vue&type=style&index=0&id=5e0197eb&lang=scss&scoped=true&"
import style1 from "./SubmissionFormForReview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0197eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
